import {
  Box,
  Container,
  Heading,
  Text,
  useColorModeValue as mode,
} from "@chakra-ui/react";

export const Layout = ({ children, ...props }) => {
  return (
    <Container as="section" {...props}>
      <Box
        maxW={{
          base: "xl",
          md: "5xl",
        }}
        mx="auto"
        px={{
          base: "6",
          md: "8",
        }}
      ></Box>
      {children}
    </Container>
  );
};

export const Header = ({ title, subtitle, ...props }) => (
  <Box
    maxW="2xl"
    mx="auto"
    textAlign={{
      sm: "center",
    }}
    {...props}
  >
    <Heading as="h1" size="md" fontWeight="extrabold" letterSpacing="tight">
      {title}
    </Heading>
    <Text mt="2" fontSize="xl">
      {subtitle}
    </Text>
  </Box>
);

export const Content = ({ children, ...props }) => {
  return (
    <Box mt={12} {...props}>
      {children}
    </Box>
  );
};
